function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Card from './components/Card';
import TabPane from './components/TabPane';
import Divider from './components/Divider';

var Group = function Group(props) {
  return /*#__PURE__*/React.createElement(Card, _extends({
    bodyStyle: {
      padding: 0
    }
  }, props));
}; // 当前不对底层 Card 做封装，仅挂载子组件，直接导出
// @ts-ignore


var ProCard = Card;
ProCard.isProCard = true;
ProCard.Divider = Divider;
ProCard.TabPane = TabPane;
ProCard.Group = Group;
export default ProCard;